import { Product, ProductSlug } from "@/api/product-api";
import { DisplayProductsInBox } from "@/components/tactsuit/components/DisplayProductsInBoxSection";
import { ProductInTheBoxData } from "@/components/tactsuit/constants/ProductInTheBox";
import { useTrans } from "@/utils/useTrans";
import React from "react";

export default function ProductsInTheBox({
  className,
  products = [],
}: {
  className?: string;
  products?: Product[];
}) {
  const { t } = useTrans(["tactsuit"]);
  const dataMap = new Map(
    products.map((p) => [p.slug, ProductInTheBoxData[p.slug]]),
  );
  const productsDataMap = products
    .map((p) => ({ ...p, productData: dataMap.get(p.slug as ProductSlug) }))
    .filter((p) => !!p.productData);

  if (productsDataMap.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-col items-center rounded-2xl bg-coolgray-10 px-4 py-7 laptop:px-10 laptop:py-10">
      <div className="mb-6 text-3xl laptop:text-5xl">{t("In the Box")}</div>
      <div className="w-full space-y-6">
        {productsDataMap.map((product, index) => {
          // 글러브(DK3) 단일 구성은 Figma상 하위 제품명 없이 3카드 중앙정렬 (27379:38994).
          // EXOSHOCK 번들도 제품명 줄 없이 192(모바일 140) 카드 5장이다(31584:38714 · 31584:39273).
          const centered =
            product.slug === ProductSlug.TACTGLOVE_DK3 ||
            product.slug === ProductSlug.EXOSHOCK_BUNDLE;
          return (
            <DisplayProductsInBox
              key={index}
              title={centered ? undefined : product.name}
              products={product.productData ?? []}
              centered={centered}
            />
          );
        })}
      </div>
    </div>
  );
}
